export enum PartnersConstants {
  NO_PARTNER_SELECTED = 'NONE',
  NO_ORGANISATION_SELECTED = 'NONE',
}
